import httpClient from './httpClient';

const getTarea = (id) => {    
    return httpClient.get(`/AppPedido/getTareaPedById/${id}`);
};

export default getTarea;